import { observable } from 'mobx';
import { noop } from '@src/utils/common-util';

class MechaInfoModalStore {
  @observable expandVideoUrl = '';
  @observable closeCallback = noop;

  // 机兵信息
  @observable mecha_history_image;

  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  /**
   * 点击关闭弹窗
   * 重写关闭事件, 补充了弹窗特定的关闭回调
   */
  onClickClose = () => {
    this.isOpen = false;
    this.isActive = false;
    this.onClose();
    this.closeCallback();
  };

  use() { }
}

export default MechaInfoModalStore;
